import { motion } from 'framer-motion';

import { cn } from '#/lib/utils';

import { defaultMotionProps } from '../motion';

export const StatsCard = ({
  className,
  captionClassName,
  statClassName,
  stat,
  caption,
  content,
  contentClassName,
}: {
  className?: string;
  captionClassName?: string;
  statClassName?: string;
  stat: string;
  caption?: string;
  content: string;
  contentClassName?: string;
}) => {
  return (
    <motion.div
      className={cn(
        'rounded-23 ml:rounded-50 p-20 ml:p-48 text-cloud',
        className,
      )}
      {...defaultMotionProps}
    >
      <h3
        className={cn(
          'ml:text-79 text-[40px] font-normal leading-[105%] tracking-[-0.79px] trim-text mb-8',
          statClassName,
        )}
      >
        {stat}
      </h3>
      {caption && (
        <p
          className={cn(
            'ml:text-32 text-18 font-normal leading-[105%] tracking-[-0.32px] text-pretty',
            captionClassName,
          )}
        >
          {caption}
        </p>
      )}
      <p
        className={cn(
          'ml:text-21 text-14 font-light leading-[136%] mt-16 ml:mt-24 text-pretty',
          contentClassName,
        )}
      >
        {content}
      </p>
    </motion.div>
  );
};
